const BRING_PROD_GOOGLE_API_KEY = 'AIzaSyCn5KvyldtSam1GwxbXupUXc1amHYfc3Ek'
const BRING_PROD_HOSTNAME = 'glow.bring.com'
const BRING_SHORT_TRACKING_PROD_HOSTNAME = 't.bring.com'
const POSTEN_PROD_HOSTNAME = 'glow.posten.no'
const POSTEN_SHORT_TRACKING_PROD_HOSTNAME = 't.posten.no'
const POSTEN_QA_HOSTNAME = 'qa.glow-posten.bring.services'
const BRING_PROD_REPORT_URL = 'https://insight.glow.bring.com/opensearch/'
const BRING_QA_GOOGLE_API_KEY = 'AIzaSyD6IoJ7EPub9WzBJMUy30aNXsUdaK9sq1g'
const BRING_QA_HOSTNAME = 'qa.glow.bring.services'
const BRING_QA_FEATURE_HOSTNAME = 'qa.glow-feature.bring.services'
const BRING_QA_REPORT_URL = 'https://insight.qa.glow.bring.services/opensearch/'
const BRING_SHORT_TRACKING_QA_HOSTNAME = 't.qa.bring.services'

const GLOW_TECHNOLOGY_GOOGLE_API_KEY = 'AIzaSyAyt1fBNDhax-NUTN1WbTAHh-HWyTwsP84'

const DEMO_QA_HOST_NAME = 'demo.glowtechnology.com'

const PILOT_HOSTNAME = 'pilot.glowtechnology.com'

const NORDISKA_GALLERIELT_PROD_HOST_NAME = 'nordiskagalleriet.glowtechnology.com'

const FOBILDRIFT_QA_HOST_NAME = 'fobildrift.qa.glowtechnology.com'
const FOBILDRIFT_PROD_HOST_NAME = 'fobildrift.glowtechnology.com'

const LOCAL_GOOGLE_API_KEY = 'AIzaSyAO7d495X98nmkdomyAza5vwnSeXIACwms'
const LOCAL_BASE_URL = 'http://localhost:10001'

/* ------------------------------------
Exported functions
------------------------------------ */

// Add new production URL's here, so that they're discovered by tests
export const ALL_PRODUCTION_URLS = [
  BRING_PROD_HOSTNAME,
  BRING_SHORT_TRACKING_PROD_HOSTNAME,
  NORDISKA_GALLERIELT_PROD_HOST_NAME,
  FOBILDRIFT_PROD_HOST_NAME,
  POSTEN_PROD_HOSTNAME,
  POSTEN_SHORT_TRACKING_PROD_HOSTNAME
]

// Add new QA URL's here, so that they're discovered by tests
export const ALL_QA_URLS = [
  BRING_QA_HOSTNAME,
  BRING_QA_FEATURE_HOSTNAME,
  BRING_SHORT_TRACKING_QA_HOSTNAME,
  POSTEN_QA_HOSTNAME,
  DEMO_QA_HOST_NAME,
  FOBILDRIFT_QA_HOST_NAME
]

const isHttp = () => window.location.protocol === 'http:'

export function webSocketUrl() {
  if (isHttp()) {
    return `ws://${window.location.host}/api/subscribe`
  } else {
    return `wss://${hostName()}/api/subscribe`
  }
}

export function baseTrackUrl() {
  // A Glow Technology tenant tracks on its own host, <tenant>[.qa].glowtechnology.com
  if (isGlowTechnology()) return `https://${hostName()}`
  else if (isBringQa()) return `https://${BRING_QA_HOSTNAME}`
  else if (isLocalhost()) return LOCAL_BASE_URL
  else return `https://${BRING_PROD_HOSTNAME}`
}

export function basePostenTrackUrl() {
  if (isLocalhost()) {
    return LOCAL_BASE_URL
  } else if (isBring()) {
    if (isBringQa()) return 'https://qa.glow-posten.bring.services'
    if (isBringProd()) return 'https://glow.posten.no'
    else return LOCAL_BASE_URL
  } else return baseTrackUrl()
}

export function isProduction() {
  return isBringProd() || isPostenProd() || isGlowTechnologyProd()
}

export function allowMockLogin(): boolean {
  return isLocalhost()
}

export function customerLoginUrl(): string {
  if (isGlowTechnology()) return '/login'
  else return '/api/auth/customer-login-initiate'
}

export function reportUrl(): string | undefined {
  if (isBring()) {
    if (isBringProd()) return BRING_PROD_REPORT_URL
    if (isBringQa()) return BRING_QA_REPORT_URL
  } else if (isLocalhost()) return BRING_PROD_REPORT_URL
}

export function sentryEnvironment() {
  // Before Bring/Posten: a tenant host may contain 'posten'
  if (isGlowTechnology()) return environmentName() + '_' + glowTechnologyTenant()
  else if (isBring() || isPosten()) return environmentName() + '_bring'
  else return environmentName()
}

export function internalFrontendSentryAPIKey(): string | undefined {
  if (!isLocalhost()) {
    return 'https://24b7d8eacbb6428cee5e5277179ecf3e@o4508409488670720.ingest.de.sentry.io/4508409495683152'
  }
}

export function customerPortalSentryAPIKey(): string | undefined {
  if (!isLocalhost()) {
    return 'https://97cafef8e07ce45a9a328fd7d3f291e6@o4508409488670720.ingest.de.sentry.io/4508409498304592'
  }
}

export function envMarker(): string | undefined {
  if (isProduction()) return
  else if (isBringQaFeature()) return 'QA FEATURE'
  else if (isBringQa()) return 'QA'
  else if (isDemo()) return 'DEMO'
  else if (isGlowTechnologyQa()) return 'QA'
  else if (isLocalhost()) return 'LOCAL'
  else if (isE2ETest()) return 'E2E'
}

export function googleAPIKey(): string | undefined {
  if (isBringProd()) return BRING_PROD_GOOGLE_API_KEY
  else if (isBringQa()) return BRING_QA_GOOGLE_API_KEY
  else if (isGlowTechnology()) return GLOW_TECHNOLOGY_GOOGLE_API_KEY
  else if (isLocalhost()) return LOCAL_GOOGLE_API_KEY
  else if (isE2ETest()) return LOCAL_GOOGLE_API_KEY
}

export function supportUrl(): string {
  if (isGlowTechnology()) {
    return 'https://glowhelpcenter.zendesk.com/hc/en-us'
  } else {
    return 'https://glowtechnology.zendesk.com'
  }
}

export function isRunningTests(): boolean {
  const env = window.process?.env
  return env?.JEST_WORKER_ID !== undefined || env?.VITEST !== undefined
}
export function isE2ETest(): boolean {
  return hostName() === 'glow-proxy' && window.location.port === '22222'
}
export function isLocalhost(): boolean {
  return hostName() === 'localhost'
}
export function trackingSentryAPIKey(): string | undefined {
  if (!isLocalhost() && !isE2ETest()) {
    return 'https://5d994eefae3afa6b6b441bce46788fc9@o4508409488670720.ingest.de.sentry.io/4508409497124944'
  }
}

export function isBringOrPosten(): boolean {
  return isBring() || isPosten()
}

export function isPosten(): boolean {
  return window.location.hostname.includes('posten')
}

export function isBring() {
  return isBringQa() || isBringProd() || isLocalhost() || isE2ETest()
}
export function isGlowTechnology() {
  return hostName().includes('.glowtechnology.com')
}

export function isDemo() {
  return hostName() == DEMO_QA_HOST_NAME
}

export function isBringQa() {
  return (
    hostName() === BRING_QA_HOSTNAME ||
    hostName() === BRING_QA_FEATURE_HOSTNAME ||
    hostName() === BRING_SHORT_TRACKING_QA_HOSTNAME
  )
}

export function isBringQaFeature() {
  return hostName() === BRING_QA_FEATURE_HOSTNAME
}

export function isPilot() {
  return hostName() == PILOT_HOSTNAME
}

export function isNordiskaGalleriet() {
  return isNordiskaGallerietProd()
}

export type Client = 'bring' | 'glow'

export function getClient(): Client {
  return isBring() ? 'bring' : 'glow'
}

export function glowFrontendDomain() {
  return window.location.hostname === 'localhost' && window.location.port === '10002'
    ? window.location.protocol + '//localhost:10000'
    : window.location.protocol + '//' + window.location.host
}

// Glow Technology tenants that run their own glow-pricemotor
const PRICING_ENGINE_TENANTS = ['fobildrift']

export function enablePricingEngine() {
  return isBring() || isDemo() || (isGlowTechnology() && PRICING_ENGINE_TENANTS.includes(glowTechnologyTenant()))
}

export function isHdEnabled() {
  return isBring() || isLocalhost() || isNordiskaGalleriet() || isDemo()
}

export function enableMandatoryVehicle() {
  return isGlowTechnology() || !isProduction()
}

export function isUnitOptional() {
  return isGlowTechnology()
}

/* ------------------------------------
private helpers
------------------------------------ */
function environmentName() {
  if (isProduction()) return 'production'
  else if (isQa()) return 'qa'
  else return 'development'
}

function isQa() {
  return isBringQa() || isPostenQa() || isGlowTechnologyQa()
}

// The first label of <tenant>[.qa].glowtechnology.com, e.g. nordiskagalleriet
function glowTechnologyTenant() {
  return hostName().split('.')[0]
}

function hostName() {
  return window.location.hostname
}

function isGlowTechnologyQa() {
  return hostName().includes('.qa.glowtechnology.com') || isDemo()
}

function isGlowTechnologyProd() {
  return isGlowTechnology() && !isGlowTechnologyQa()
}

export function isBringProd() {
  return hostName() === BRING_PROD_HOSTNAME || hostName() == BRING_SHORT_TRACKING_PROD_HOSTNAME
}

function isPostenProd() {
  return hostName() === POSTEN_PROD_HOSTNAME || hostName() == POSTEN_SHORT_TRACKING_PROD_HOSTNAME
}

function isPostenQa() {
  return hostName() === POSTEN_QA_HOSTNAME
}

function isNordiskaGallerietProd() {
  return hostName() === NORDISKA_GALLERIELT_PROD_HOST_NAME
}
